import { useEffect, useState } from "react";
import {
  getRsvpReservation,
  RSVP_CHANGED_EVENT,
  type RsvpReservation,
} from "../lib/rsvpAck";

export function useRsvpReservation(
  eventId: number | null | undefined,
): RsvpReservation | null {
  const [reservation, setReservation] = useState<RsvpReservation | null>(() =>
    getRsvpReservation(eventId),
  );

  useEffect(() => {
    const sync = () => setReservation(getRsvpReservation(eventId));
    sync();
    window.addEventListener(RSVP_CHANGED_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(RSVP_CHANGED_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [eventId]);

  return reservation;
}
